import { Box } from '@factorialco/deprecated-design-system'

import ImportDatevLauds from '../components/ImportDatevLauds'

const ImportDatevLaudsPage = () => {
  return (
    <Box width="full" padding="s24">
      <ImportDatevLauds />
    </Box>
  )
}

export default ImportDatevLaudsPage
